 <template>
  <div id="cotizador">
    <b-navbar toggleable="lg" class="bg-createch">
      <b-navbar-brand href="#">
        <a class="navbar-brand mr-auto mr-lg-0" href="#">
          <img src="../../assets/img/logo.svg" height="60" width="auto" alt />
        </a>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <router-link class="nav-link boton_createch_2" to="/inicio">Regresar</router-link>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <full-page :options="options_full" ref="fullpage">
      <div class="section">
        <div class="slide mt-5 p-2">
          <b-container>
            <b-row class="mb-2">
              <b-col>
                <b-button
                  pill
                  class="btn-createch"
                  v-on:click="add_client = !add_client"
                >Agregar cliente</b-button>
                <b-button
                  pill
                  class="btn-createch ml-2"
                  v-on:click="add_services = !add_services"
                >Agregar No. servicio</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h2>Información del cliente</h2>
                <div class="clienete_informacion">
                  <b-form-group label="Cliente">
                    <v-select
                      label="email"
                      class="style-chooser"
                      :options="data.clientes"
                      v-model="data.cotizacion.cliente.informacion"
                      @change="ObtenerServicios()"
                    >
                      <span slot="no-options">No hay resultados.</span>
                      <template
                        slot="option"
                        slot-scope="option"
                      >{{ option.firstname }} {{ option.lastname }} - {{ option.email }}</template>
                    </v-select>
                  </b-form-group>

                  <b-form-group label="Nombre" v-if="data.cotizacion.cliente.informacion">
                    <b-form-input v-model="data.cotizacion.cliente.informacion.firstname" disabled />
                  </b-form-group>
                  <b-form-group label="Apellido" v-if="data.cotizacion.cliente.informacion">
                    <b-form-input v-model="data.cotizacion.cliente.informacion.lastname" disabled />
                  </b-form-group>
                  <b-form-group label="No. Servicio">
                    <v-select
                      label="snumber"
                      class="style-chooser"
                      v-model="data.servicio"
                      :options="data.servicios"
                    >
                      <span slot="no-options">No hay resultados.</span>
                      <template slot="option" slot-scope="option">{{ option.snumber }}</template>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div class="slide mt-5 p-2" id="consumo">
          <b-container>
            <b-row>
              <b-col sm="10" class="pruebas">
                <b-row
                  v-for="(item, index) in data.cotizacion.informacion_consumo.consumo_mensual.slice(0, 12)"
                  :key="index"
                >
                  <b-col :sm="data.cotizacion.pago == 'Medio' ? '2' : '4'">
                    <p>{{item.mes}}</p>
                  </b-col>
                  <b-col :sm="show && (data.cotizacion.pago == 'Medio' ? '2' : '4')">
                    <b-input-group id="input-group-3" label-for="input-3" class>
                      <b-input-group-prepend is-text>
                        <i class="fas fa-bolt"></i>
                      </b-input-group-prepend>
                      <b-form-input
                        id="input-2"
                        v-model="item.consumo"
                        required
                        type="number"
                        :disabled="data.cotizacion.pago == 'Medio'"
                        v-on:change="PrecioMensual($event, index, item)"
                      />
                    </b-input-group>
                  </b-col>
                  <b-col :sm="show && (data.cotizacion.pago == 'Medio' ? '2' : '4')">
                    <b-input-group id="input-group-3" label-for="input-3" class="mb-1">
                      <b-input-group-prepend is-text>
                        <i class="fas fa-dollar-sign"></i>
                      </b-input-group-prepend>
                      <b-form-input
                        id="input-2"
                        v-model="item.precio"
                        required
                        type="number"
                        :disabled="data.cotizacion.pago == 'Medio'"
                        v-on:change="PrecioMensual($event, index, item)"
                      />
                    </b-input-group>
                  </b-col>
                  <transition enter-active-class="animated fadeInRight">
                    <b-col sm="3" v-if="show && data.cotizacion.pago == 'Medio'">
                      <b-input-group
                        id="input-group-3"
                        label-for="input-3"
                        class="mb-1"
                        v-if="(data.cotizacion.pago == 'Medio' && (index % 2) == 0)"
                      >
                        <b-input-group-prepend is-text>
                          <i class="fas fa-bolt"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          id="input-2"
                          v-model="data.cotizacion.informacion_consumo.consumo_mensual_bimensual[index].consumo"
                          @keyup="consumoInput(index)"
                          @change="consumoInput(index)"
                          required
                          type="number"
                          :disabled="(index % 2) == 1"
                        />
                      </b-input-group>
                    </b-col>
                  </transition>
                  <transition enter-active-class="animated fadeInRight">
                    <b-col sm="3" v-if="show && data.cotizacion.pago == 'Medio'">
                      <b-input-group
                        id="input-group-3"
                        label-for="input-3"
                        class="mb-1"
                        v-if="(data.cotizacion.pago == 'Medio' && (index % 2) == 0)"
                      >
                        <b-input-group-prepend is-text>
                          <i class="fas fa-dollar-sign"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          id="input-2"
                          v-model="data.cotizacion.informacion_consumo.consumo_mensual_bimensual[index].precio"
                          @keyup="precioInput(index, $event)"
                          @change="precioInput(index)"
                          required
                          type="number"
                          :disabled="(index % 2) == 1"
                        />
                      </b-input-group>
                    </b-col>
                  </transition>
                </b-row>
              </b-col>
              <b-col sm="2">
                <b-form-group id="input-group-3" label-for="input-3">
                  <b-form-select
                    v-model="data.cotizacion.pago"
                    :options="data.tipo_recibo"
                    required
                  ></b-form-select>
                </b-form-group>
                <h3>Consumo total</h3>
                {{consumo_total}}
                <h3>Pago total</h3>
                {{total}}
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div class="slide mt-5 p-2" id="consumo" style="overflow-y: scroll; height:100%">
          <b-container>
            <b-row>
              <b-col sm="3">
                <p>Tamaño</p>
                <span>{{tamano}} Kwp</span>
              </b-col>
              <b-col sm="3">
                <p>Producción mensual</p>
                <span>{{formatKwh(ProduccionMensual)}} Kwh</span>
              </b-col>
              <b-col sm="3">
                <p>Precio del sistema</p>
                <span>{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format((packageInfo.total*packageInfo.dollar))}}</span>
                 
              </b-col>
              <b-col sm="3">
                <p>Ahorro mensual</p>
                <span>$34.565.00</span>
              </b-col>
            </b-row>
            <b-row class="mt-5">
              <b-col sm="3">
                <p>Precio mensual de consumo</p>
                <span>{{formatKwh(consumo_total/12)}} Kwh</span>
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="3">
                <p>Retorno de la inversión</p>
                <span>0.65 años</span>
              </b-col>
              <b-col sm="3">
                <p>Retorno de la inversión</p>
                <span>96%</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                sm="3"
                v-if="(data.servicio !== null && data.servicio.contractType != 'Dómestico')"
              >
                <b-form-group label="Costo promedio tarifa">
                  <b-form-input v-model="data.cotizacion.costo_promedio_tarifa" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-5 ahorro">
              <b-col md="6" offset-md="3">
                <input
                  type="range"
                  class="form-control-range"
                  min="0"
                  max="100"
                  step="1"
                  v-model="data.cotizacion.informacion_consumo.porcentaje_cobertura"
                />
              </b-col>
              <b-col>
                <span
                  style="text-align:center;"
                >{{data.cotizacion.informacion_consumo.porcentaje_cobertura}}%</span>
                <h3>Porcentaje de cobertura elétrica</h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="5">
                <b-table
                  :items="data.cotizacion.informacion_consumo.consumo_mensual.slice(0, 12)"
                  :fields="data.cotizacion.informacion_consumo.fields"
                ></b-table>
              </b-col>
              <b-col sm="3">
                <table class="table table-striped" style="text-align:center;">
                  <thead>
                    <tr>
                      <th scope="col">kWh/mes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="index in 12" :key="index">
                      <th scope="row">
                        {{ProduccionMensual}}
                        <!-- {{total/30}} -->
                      </th>
                    </tr>
                  </tbody>
                </table>
              </b-col>
              <b-col sm="4">
                <table class="table table-success" style="text-align:center;">
                  <thead>
                    <tr>
                      <th scope="col">kWh/mes</th>
                      <th scope="col">$Pago/mes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in data.cotizacion.informacion_consumo.consumo_mensual_ahorro.slice(12, 24)"
                      :key="index"
                    >
                      <th scope="row">
                        {{item.consumo}}
                        <!-- {{total/30}} -->
                      </th>
                      <th scope="row">
                        {{item.pago}}
                        <!-- {{total/30}} -->
                      </th>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-container>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
        <div class="slide mt-5 p-2">
          <b-container> 
            <b-row>
              <b-col>
                <b-form-group label="packages">
                  <b-form-radio-group v-model="packageSelected" :options="publicPackages"></b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-for="(row,index) in rows" v-bind:key="index">
              <b-col sm="4">
                <b-form-group>
                  <b-form-select
                    @change="getProductsByType(index,row.type)"
                    :options="productTypes"
                    v-model="row.type"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <b-form-select
                    required
                    @change="selectProduct(index)"
                    :options="row.options"
                    v-model="row.product"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="1">
                <b-form-group>
                  <b-form-input
                    @change="getTotalPrice(index)"
                    v-on:keypress="verifyQuantity($event)"
                    v-on:keyup="getTotalPrice(index)"
                    type="number"
                    min="1"
                    v-model.number="row.quantity"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="1">
                <b-form-group>
                  <b-button
                    variant="danger"
                    size="sm"
                    style="margin:3px;"
                    @click="removeProduct(index)"
                    v-if="rows.length>1"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <b-button variant="light" class="float-left" @click="addRow()">
                  <i class="fas fa-plus-circle"></i> Agregar producto
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col sm="12">
                <h4 class="mb-3">Detalles del paquete:</h4>
                <b-table-simple bordered small>
                  <b-thead>
                    <b-tr>
                      <b-th class="text-left">Nombre del producto</b-th>
                      <b-th class="text-center" style="width:8%">Cantidad</b-th>
                      <b-th class="text-center" style="width:13%">Precio unitario</b-th>
                      <b-th class="text-center" style="width:8%">Descuento</b-th>
                      <b-th class="text-center" style="width:13%">Total USD</b-th>
                      <b-th class="text-center" style="width:16%">Total MXN</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody v-for="(row, index) in rows" v-bind:key="index">
                    <b-tr v-if="row.product!=null">
                      <b-td>
                        {{products[row.product].productName}} Marca:
                        <label
                          v-if="products[row.product].brand == null"
                        >N/A</label>
                        <label
                          v-if="products[row.product].brand != null"
                        >{{products[row.product].brand.Nombre}}</label>
                      </b-td>
                      <b-td>
                        <b-form-input
                          type="number"
                          v-model.number="row.quantity"
                          size="sm"
                          min="1"
                          @change="getTotalPrice(index)"
                          v-on:keypress="verifyQuantity($event)"
                          v-on:keyup="getTotalPrice(index)"
                        ></b-form-input>
                      </b-td>
                      <b-td>{{products[row.product].price}}</b-td>
                      <b-td class="text-center">
                        <b-button variant="primary" size="sm" @click="showDiscRow(index)">Agregar</b-button>
                      </b-td>
                      <b-td>{{Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(row.price)}}</b-td>
                      <b-td>{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format((row.price*packageInfo.dollar))}}</b-td>
                    </b-tr>
                    <b-tr v-if="row.product!=null && row.showDisc == true">
                      <b-td colspan="4" class="text-right">Descuento por producto:</b-td>
                      <b-td colspan="1">
                        <b-input
                          type="number"
                          size="sm"
                          min="0"
                          v-model="row.disc"
                          @change="getTotalPrice(index)"
                          v-on:keypress="verifyDiscount($event)"
                          v-on:keyup="getTotalPrice(index)"
                          required
                        ></b-input>
                      </b-td>
                      <b-td colspan="1">
                        <b-input
                          type="number"
                          size="sm"
                          min="0"
                          v-model="row.discPesos"
                          @change="getTotalPrice(index)"
                          v-on:keypress="verifyDiscount($event)"
                          v-on:keyup="getTotalPrice(index)"
                          required
                        ></b-input>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                  <b-tfoot :bordered="false">
                    <b-tr>
                      <b-td variant="secondary" colspan="4" class="text-right">Subtotal:</b-td>
                      <b-td variant="secondary">
                        <b>{{Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(packageInfo.subtotal)}} USD</b>
                      </b-td>
                      <b-td variant="secondary">
                        <b>{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(packageInfo.subtotalPesos)}} MXN</b>
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td variant="secondary" colspan="4" class="text-right">IVA:</b-td>
                      <b-td variant="secondary">
                        <b>{{Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(packageInfo.totalIVA)}} USD</b>
                      </b-td>
                      <b-td variant="secondary">
                        <b>{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(packageInfo.totalIVAPesos)}} MXN</b>
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td variant="secondary" colspan="4" class="text-right">Descuento:</b-td>
                      <b-td variant="secondary">
                        <b-form-input
                          type="number"
                          size="sm"
                          min="0"
                          v-model="packageInfo.disc"
                          @change="getTotal()"
                          v-on:keypress="verifyDiscount($event)"
                          v-on:keyup="getTotal()"
                          required
                        ></b-form-input>
                      </b-td>
                      <b-td variant="secondary">
                        <b-form-input
                          type="number"
                          size="sm"
                          min="0"
                          v-model="packageInfo.discPesos"
                          @change="getTotal()"
                          v-on:keypress="verifyDiscount($event)"
                          v-on:keyup="getTotal()"
                          required
                        ></b-form-input>
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td variant="secondary" colspan="4" class="text-right">Total:</b-td>
                      <b-td variant="secondary">
                        <b>{{Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(packageInfo.total)}} USD</b>
                      </b-td>
                      <b-td variant="secondary">
                        <b>{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(packageInfo.totalPesos)}} MXN</b>
                      </b-td>
                    </b-tr>
                  </b-tfoot>
                </b-table-simple>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div class="slide mt-5 p-2">
          <b-container>
            <b-row>cc</b-row>
          </b-container>
        </div>
        <div class="slide mt-5 p-2"></div>
        <div class="slide mt-5 p-2">
          <b-container>
            <b-row class="mb-2">
              <b-col>
                <b-button pill class="btn-createch" @click="addQuote()">Guardar cotización</b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <ul class="actions">
        <li
          @click="$refs.fullpage.api.moveSlideLeft()"
          class="actions-button btn-circle btn-xl"
          style="float:left;"
        >
          <i class="fas fa-arrow-left"></i>
        </li>
        <li
          @click="$refs.fullpage.api.moveSlideRight()"
          class="actions-button btn-circle btn-xl"
          style="float:right;"
        >
          <i class="fas fa-arrow-right"></i>
        </li>
      </ul>
    </full-page>
    <b-sidebar id="sidebar-1" title="Agregar nuevo cliente" :visible="add_client">
      <div class="px-3 py-2">
        <b-form @submit="onSubmit" v-if="show" style="width: 100%;">
          <b-row>
            <b-col>
              <b-form-group label="Nombres">
                <b-form-input
                  v-model="data.form.Firstname"
                  type="text"
                  required
                  placeholder="Nombre"
                />
              </b-form-group>
              <b-form-group label="Apellidos">
                <b-form-input
                  v-model="data.form.Lastname"
                  type="text"
                  required
                  placeholder="Apellidos"
                />
              </b-form-group>
              <b-form-group label="Teléfono">
                <b-form-input
                  v-model="data.form.phoneNumber"
                  type="tel"
                  required
                  placeholder="Teléfono"
                />
              </b-form-group>
              <b-form-group label="Correo electronico">
                <b-form-input
                  v-model="data.form.Email"
                  type="email"
                  required
                  placeholder="Correo electronico"
                />
              </b-form-group>
            </b-col>
            {{data.form}}
          </b-row>
          <b-button variant="primary" class="float-right" @click="registrar()">
            <i class="far fa-save"></i> Guardar
          </b-button>
        </b-form>
      </div>
    </b-sidebar>
    <b-sidebar id="sidebar-2" title="Agregar No. Servicio" :visible="add_services" width="600px">
      <div class="px-3 py-2">
        <b-container>
          <b-form @submit="onSubmit" v-if="show">
            <b-row>
              <b-col>
                <b-form-group label="Cliente">
                  <v-select
                    label="email"
                    class="style-chooser"
                    :options="data.clientes"
                    v-model="data.cotizacion.cliente.informacion"
                  >
                    <span slot="no-options">No hay resultados.</span>
                    <template
                      slot="option"
                      slot-scope="option"
                    >{{ option.firstname }} {{ option.lastname }} - {{ option.email }}</template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col>
                <b-form-group label="No. servicio">
                  <b-form-input
                    v-model="data.snumber.snumber"
                    type="text"
                    required
                    placeholder="No. servicio"
                  />
                </b-form-group>
                <b-form-group label="Dirección">
                  <b-form-input
                    v-model="data.snumber.address"
                    type="text"
                    required
                    placeholder="Dirección"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Ubicación">
                  <v-select
                    label="name"
                    :options="data.ciudades"
                    v-model="data.cotizacion.ubicacion"
                    required
                  >
                    <span slot="no-options">No hay resultados.</span>
                    <template
                      slot="option2"
                      slot-scope="option2"
                      v-if="data.cotizacion.ubicacion.name != null"
                    >{{ option2.name }}</template>
                  </v-select>
                </b-form-group>
                <b-form-group label="Tarifa" v-if="data.cotizacion.ubicacion.name != null">
                  <v-select
                    label="name"
                    :options="data.cotizacion.ubicacion.tariffs"
                    v-model="data.cotizacion.tariffs"
                    required
                  >
                    <span slot="no-options">No hay resultados.</span>
                    <template slot="option2" slot-scope="option2">{{ option2.name }}</template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col>
                <b-form-group label="Nombre">
                  <b-form-input
                    v-model="data.snumber.contact.name"
                    type="text"
                    required
                    placeholder="Nombre"
                  />
                </b-form-group>
                <b-form-group label="Teléfono">
                  <b-form-input
                    v-model="data.snumber.contact.phoneNumber"
                    type="text"
                    required
                    placeholder="Teléfono"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Correo electrónico">
                  <b-form-input
                    v-model="data.snumber.contact.email"
                    type="email"
                    required
                    placeholder="Correo electrónico"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col>
                <b-form-group>
                  <b-form-select
                    v-model="data.snumber.billType"
                    :options="data.tipo_recibo"
                    required
                  ></b-form-select>
                </b-form-group>
                <b-form-group>
                  <b-form-select
                    v-model="data.snumber.contractType"
                    :options="data.tipo_contrato"
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-button
              variant="primary"
              class="float-right"
              type="submit"
              v-on:click="addServices()"
            >
              <i class="far fa-save"></i> Guardar
            </b-button>
          </b-form>
          {{data.snumber}}
        </b-container>
      </div>
    </b-sidebar>
  </div>
</template> 
<script>
import axios from "axios";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      show: true,
      add_client: false,
      add_services: false,
      options_full: {
        menu: "#menu_cotizador",
        navigation: false,
        slidesNavigation: true,
        controlArrows: false,
        normalScrollElements: ".style-chooser, .pruebas",
        keyboardScrolling: false,
        slidesNavPosition: "top",
        navigationPosition: "center",
        anchors: ["page1", "page2", "page3", "page4", "page5", "page6"],
        sectionsColor: ["#f8f9fa", "#f8f9fa"],
        verticalCentered: false,
        autoScrolling: true,
        fitToSection: true
      },
      data: {
        cotizacion: {
          cliente: {
            informacion: null
          },
          ubicacion: { Generacion: 1650 },
          contrato: null,
          recibo: null
        },
        servicios: [],
        clientes: [],
        form: {
          Firstname: "",
          Lastname: "",
          Password: "",
          PasswordRepeat: "",
          Email: "",
          Rol: "Cliente",
          phoneNumber: null
        },
        ciudades: [],
        tipo_recibo: [
          { text: "Tipo de recibo", value: null },
          { text: "Pago Mensual", value: "Mensual" },
          { text: "Precio Medio", value: "Medio" }
        ],
        tipo_contrato: [
          { text: "Tipo de contrato", value: null },
          { text: "Doméstico", value: "Doméstico" },
          { text: "Industrial", value: "Industrial" },
          { text: "Comercial", value: "Comercial" }
        ],
        servicio: null,
        snumber: {
          snumber: null,
          address: null,
          city: null,
          contact: {
            phoneNumber: null,
            name: null,
            email: null
          },
          assignedTo: null,
          owner: null,
          contractType: null,
          billType: null,
          tariff: null
        },
        cotizacion: {
          cliente: {
            correo: null
          },
          ubicacion: { Generacion: 1650, name: null },
          recibo: null,
          contrato: null,
          costo_promedio_tarifa: null,
          pago: null,
          consumo: [],
          ahorro: [],
          informacion_consumo: {
            consumo_promedio_mensual: 0,
            perdidas: 0,
            consumo_mensual: [
              {
                mes: "Enero",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Febrero",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Marzo",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Abril",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Mayo",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Junio",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Julio",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Agosto",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Septiembre",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Octubre",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Noviembre",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Diciembre",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Enero",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Febrero",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Marzo",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Abril",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Mayo",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Junio",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Julio",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Agosto",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Septiembre",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Octubre",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Noviembre",
                consumo: null,
                precio_promedio: null,
                precio: null
              },
              {
                mes: "Diciembre",
                consumo: null,
                precio_promedio: null,
                precio: null
              }
            ],
            consumo_mensual_bimensual: [
              { mes: "Enero", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Febrero", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Marzo", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Abril", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Mayo", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Junio", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Julio", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Agosto", consumo: null, precio_promedio: 0, precio: 0 },
              {
                mes: "Septiembre",
                consumo: null,
                precio_promedio: 0,
                precio: 0
              },
              { mes: "Octubre", consumo: null, precio_promedio: 0, precio: 0 },
              {
                mes: "Noviembre",
                consumo: null,
                precio_promedio: 0,
                precio: 0
              },
              {
                mes: "Diciembre",
                consumo: null,
                precio_promedio: 0,
                precio: 0
              },
              { mes: "Enero", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Febrero", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Marzo", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Abril", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Mayo", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Junio", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Julio", consumo: null, precio_promedio: 0, precio: 0 },
              { mes: "Agosto", consumo: null, precio_promedio: 0, precio: 0 },
              {
                mes: "Septiembre",
                consumo: null,
                precio_promedio: 0,
                precio: 0
              },
              { mes: "Octubre", consumo: null, precio_promedio: 0, precio: 0 },
              {
                mes: "Noviembre",
                consumo: null,
                precio_promedio: 0,
                precio: 0
              },
              { mes: "Diciembre", consumo: null, precio_promedio: 0, precio: 0 }
            ],
            fields: [
              { key: "mes", label: "Mes" },
              { key: "consumo", label: "kWh/mes" },
              { key: "precio_promedio", label: "Precio Medio" },
              { key: "precio", label: "$Pago/mes" }
            ],
            consumo_mensual_ahorro: [
              { mes: "Enero", consumo: null, pago: 0 },
              { mes: "Febrero", consumo: null, pago: 0 },
              { mes: "Marzo", consumo: null, pago: 0 },
              { mes: "Abril", consumo: null, pago: 0 },
              { mes: "Mayo", consumo: null, pago: 0 },
              { mes: "Junio", consumo: null, pago: 0 },
              { mes: "Julio", consumo: null, pago: 0 },
              { mes: "Agosto", consumo: null, pago: 0 },
              { mes: "Septiembre", consumo: null, pago: 0 },
              { mes: "Octubre", consumo: null, pago: 0 },
              { mes: "Noviembre", consumo: null, pago: 0 },
              { mes: "Diciembre", consumo: null, pago: 0 },
              { mes: "Enero", consumo: null, pago: 0 },
              { mes: "Febrero", consumo: null, pago: 0 },
              { mes: "Marzo", consumo: null, pago: 0 },
              { mes: "Abril", consumo: null, pago: 0 },
              { mes: "Mayo", consumo: null, pago: 0 },
              { mes: "Junio", consumo: null, pago: 0 },
              { mes: "Julio", consumo: null, pago: 0 },
              { mes: "Agosto", consumo: null, pago: 0 },
              { mes: "Septiembre", consumo: null, pago: 0 },
              { mes: "Octubre", consumo: null, pago: 0 },
              { mes: "Noviembre", consumo: null, pago: 0 },
              { mes: "Diciembre", consumo: null, pago: 0 }
            ],
            fields2: [
              { key: "consumo", label: "kWh/mes" },
              { key: "pago", label: "$Pago/mes" }
            ],
            porcentaje_cobertura: 100
          }
        },
        pack: 'prueba'
      },
      rows: [
        {
          product: null,
          quantity: 1,
          options: [],
          type: null,
          price: 0,
          pricePesos: 0,
          disc: 0,
          discPesos: 0,
          showDisc: false
        }
      ],
      AllProductsOptions: [{ text: "Selecciona producto", value: null }],
      products: [],
      productTypes: [],
      packageInfo: {
        subtotal: 0,
        subtotalPesos: 0,
        total: 0,
        totalPesos: 0,
        totalIVA: 0,
        totalIVAPesos: 0,
        disc: 0,
        discPesos: 0,
        iva: 16,
        dollar: 18.84
      },
      publicPackages: [],
      packageSelected: ""
    };
  },
  created() {
    this.getClientes();
    this.getCiudades();
    this.getServicios();
    this.getPackages();
    this.getProducts();
    this.getProductTypes();
  },
  watch: {
    ProduccionMensual: function() {
      let consumo_mensual_ahorro = this.data.cotizacion.informacion_consumo
        .consumo_mensual_ahorro;
      consumo_mensual_ahorro[0].consumo = (
        this.data.cotizacion.informacion_consumo.consumo_mensual[0].consumo -
        this.ProduccionMensual
      ).toFixed(2);
      for (
        let index = 1;
        index <
        this.data.cotizacion.informacion_consumo.consumo_mensual_ahorro.length;
        index++
      ) {
        if (consumo_mensual_ahorro[index - 1].consumo < 0) {
          consumo_mensual_ahorro[index].consumo = (
            parseFloat(consumo_mensual_ahorro[index - 1].consumo) +
            parseFloat(
              this.data.cotizacion.informacion_consumo.consumo_mensual[index]
                .consumo
            ) -
            parseFloat(this.ProduccionMensual)
          ).toFixed(2);
        } else {
          consumo_mensual_ahorro[index].consumo = (
            this.data.cotizacion.informacion_consumo.consumo_mensual[index]
              .consumo - this.ProduccionMensual
          ).toFixed(2);
        }
        if (consumo_mensual_ahorro[index].consumo > 0) {
          consumo_mensual_ahorro[index].pago = (
            parseFloat(consumo_mensual_ahorro[index].consumo) *
            parseFloat(this.data.cotizacion.costo_promedio_tarifa) *
            1.16
          ).toFixed(2);
        } else {
          consumo_mensual_ahorro[index].pago = 0;
        }
      }
    },
    "data.cotizacion.cliente.informacion": function() {
      this.data.snumber.assignedTo = this.$store.state.usuario._id;
      this.data.snumber.owner = this.data.cotizacion.cliente.informacion._id;
      let me = this; 
      axios
        .get("snumbers/"+this.data.cotizacion.cliente.informacion._id)
        .then(function(response) {  
          me.data.servicios = response.data; 
        })
        .catch(function(error) {});  
    },
    "data.cotizacion.ubicacion": function() {
      this.data.snumber.city = this.data.cotizacion.ubicacion._id;
    },
    "data.cotizacion.tariffs": function() {
      this.data.snumber.tariff = this.data.cotizacion.tariffs._id;
    },
    "data.servicio": function() {
      this.data.cotizacion.pago = this.data.servicio.billType;
    },
    packageSelected: function() {
      this.selectPackage();
    }
  },
  methods: {
    getClientes() {
      let me = this;
      axios
        .get("customers/" + this.$store.state.usuario._id + "/status=true")
        .then(function(response) {
          me.data.clientes = response.data.customers;
        })
        .catch(function(error) {});
    },
    addServices() {
      this.isLoading = true;
      axios
        .post("snumber", {
          snumber: this.data.snumber.snumber,
          address: this.data.snumber.address,
          city: this.data.snumber.city,
          contact: {
            phoneNumber: this.data.snumber.contact.phoneNumber,
            name: this.data.snumber.contact.name,
            email: this.data.snumber.contact.email
          },
          assignedTo: this.data.snumber.assignedTo,
          owner: this.data.snumber.owner,
          contractType: this.data.snumber.contractType,
          billType: this.data.snumber.billType,
          tariff: this.data.snumber.tariff
        })
        .then(respuesta => {
          return respuesta;
          this.isLoading = false;
          this.getServicios();
        })
        .then(data => {
          this.data.snumber.snumber = null;
          this.data.snumber.address = null;
          this.data.snumber.contact.phoneNumber = null;
          this.data.snumber.contact.name = null;
          this.data.snumber.contact.email = null;
          this.data.snumber.assignedTo = null;
          this.data.snumber.owner = null;
          this.data.snumber.contractType = null;
          this.data.snumber.billType = null;
          this.data.snumer.tariff = null;
          this.isLoading = false;
          this.add_services = !this.add_services;
        })
        .catch(error => {
          this.errorM = null;
          if (error.response.data == "Servicio ya existe") {
            this.makeToast(
              this.$bvToast.toast(error.response.data, {
                title: "Error",
                toaster: "b-toaster-top-right",
                variant: "danger",
                solid: true
              })
            );
            this.isLoading = false;
          } else {
            this.errorM = "Ocurrió un error revisa los campos.";
            this.isLoading = false;
          }
        });
    },
    registrar() {
      this.isLoading = true;
      axios
        .post("user", {
          id_creador: this.$store.state.usuario._id,
          usuario: {
            firstname: this.data.form.Firstname,
            lastname: this.data.form.Lastname,
            email: this.data.form.Email,
            phoneNumber: this.data.form.phoneNumber,
            rol: "Cliente"
          }
        })
        .then(respuesta => {
          return respuesta;
          this.isLoading = false;
        })
        .then(data => {
          this.data.form.Firstname = "";
          this.data.form.Lastname = "";
          this.data.form.Password = "";
          this.data.form.Email = "";
          this.data.form.Rol = "";
          this.data.form.phoneNumber = null;
          this.getClientes();
          this.isLoading = false;
          this.add_client = !this.add_client;
        })
        .catch(error => {
          this.errorM = null;
          if (error.response.data == "Usuario ya existe") {
            this.makeToast(
              this.$bvToast.toast(error.response.data, {
                title: "Error",
                toaster: "b-toaster-top-right",
                variant: "danger",
                solid: true
              })
            );
            this.isLoading = false;
          } else {
            this.errorM = "Ocurrió un error revisa los campos.";
            this.isLoading = false;
          }
        });
    },
    addQuote() {
      let me = this;
      let id_quote = null;
      axios
        .post("quotes", {
          employee: this.$store.state.usuario._id,
          customer: this.data.cotizacion.cliente.informacion._id,
          data: this.data
        })
         
        .then(function(response) {
          id_quote = response.data; 
          return response;
        })
        .then(() => {
           this.$router.push({ name: "cotizacion_confirmado",  params: { id: id_quote } });
        })
        .catch(function(error) {});
    },
    ObtenerServicios(){
      let me = this;
      axios
        .get("quotes/"+this.data.cotizacion.cliente.informacion._id)
        .then(function(response) {
           me.data.servicios = null;
          me.data.servicios = response.data; 
        })
        .catch(function(error) {}); 
    },
    onEnter: function() {
      this.registrar();
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.registrar();
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.Firstname = "";
      this.form.Lastname = "";
      this.form.Password = "";
      this.form.Email = "";
      this.form.Rol = "";
    },
    getCiudades() {
      let me = this;
      axios
        .get("cities")
        .then(function(response) {
          me.data.ciudades = response.data;
        })
        .catch(function(error) {});
    },
    getServicios() {
      let me = this;
      axios
        .get("assignedsnumbers/" + this.$store.state.usuario._id)
        .then(function(response) {
          me.data.servicios = response.data;
        })
        .catch(function(error) {});
    },
    consumoInput(index) {
      let mensual = this.data.cotizacion.informacion_consumo.consumo_mensual;
      let bimensual = this.data.cotizacion.informacion_consumo
        .consumo_mensual_bimensual;
      mensual[index].consumo = bimensual[index].consumo / 2;
      mensual[index + 1].consumo = bimensual[index].consumo / 2;

      mensual[index + 12].consumo = mensual[index].consumo;
      mensual[index + 13].consumo = mensual[index].consumo;
    },
    precioInput(index, event) {
      let mensual = this.data.cotizacion.informacion_consumo.consumo_mensual;
      let bimensual = this.data.cotizacion.informacion_consumo
        .consumo_mensual_bimensual;
      mensual[index].precio = bimensual[index].precio / 2;
      mensual[index + 1].precio = bimensual[index].precio / 2;

      mensual[index + 12].precio = mensual[index].precio;
      mensual[index + 13].precio = mensual[index].precio;
    },
    PrecioMensual(event, index, item) {
      this.data.cotizacion.informacion_consumo.consumo_mensual[
        index
      ].precio_promedio = (
        this.data.cotizacion.informacion_consumo.consumo_mensual[index].precio /
        1.16 /
        this.data.cotizacion.informacion_consumo.consumo_mensual[index].consumo
      ).toFixed(2);

      this.data.cotizacion.informacion_consumo.consumo_mensual[
        index + 12
      ].consumo = this.data.cotizacion.informacion_consumo.consumo_mensual[
        index
      ].consumo;
      this.data.cotizacion.informacion_consumo.consumo_mensual[
        index + 12
      ].precio = this.data.cotizacion.informacion_consumo.consumo_mensual[
        index
      ].precio;
      this.data.cotizacion.informacion_consumo.consumo_mensual[
        index + 12
      ].precio_promedio = this.data.cotizacion.informacion_consumo.consumo_mensual[
        index
      ].precio_promedio;
    },
    formatKwh(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getPackages() {
      axios.get("publicpackages").then(res => {
        this.packages = res.data;
        this.publicPackages = res.data.map(pack => ({
          text: pack.packageName,
          value: pack.packageName
        }));
        this.publicPackages.push({
          text: "Personalizado",
          value: ""
        });
      });
    },
    getProducts() {
      axios.get("products").then(res => {
        if (res.data) {
          this.products = res.data;
          for (const p of this.products) {
            if (p.brand != null) {
              this.AllProductsOptions.push({
                text: `${p.productName} Marca: ${p.brand.name}`,
                value: this.products.indexOf(p)
              });
            } else {
              this.AllProductsOptions.push({
                text: `${p.productName} Marca: N/A`,
                value: this.products.indexOf(p)
              });
            }
          }
          this.rows[0].options = [...this.AllProductsOptions];
        }
      });
    },
    getProductTypes() {
      axios
        .get("types")
        .then(res => {
          if (res.data) {
            this.productTypes.push({ text: "Selecciona tipo", value: null });
            for (const type of res.data) {
              this.productTypes.push({ text: type.name, value: type._id });
            }
          }
        })
        .catch(error => {});
    },
    addRow() {
      this.rows.push({
        type: null,
        product: null,
        quantity: 1,
        products: [],
        options: [],
        compatibility: null,
        price: 0,
        pricePesos: 0,
        disc: 0,
        discPesos: 0,
        showDisc: false
      });
      this.rows[this.rows.length - 1].options = [...this.AllProductsOptions];
    },
    getProductsByType(index, type) {
      console.log(type);

      if (type != null) {
        this.rows[index].product = null;
        this.rows[index].quantity = 1;
        this.rows[index].options.splice(1);
        const newOptions = this.products.filter(p => p.type._id == type);
        for (const p of newOptions) {
          if (p.brand != null) {
            this.rows[index].options.push({
              text: `${p.productName} Marca: ${p.brand.name}`,
              value: this.products.indexOf(p)
            });
          } else {
            this.rows[index].options.push({
              text: `${p.productName} Marca: N/A`,
              value: this.products.indexOf(p)
            });
          }
        }
        this.getTotalPrice(index);
      } else {
        this.rows[index].product = null;
        this.rows[index].quantity = 1;
        this.rows[index].options = [];
        this.rows[index].options = [...this.AllProductsOptions];
        this.getTotalPrice(index);
      }
    },
    selectProduct(index) {
      this.rows[index].quantity = 1;
      this.getTotalPrice(index);
      console.log(this.rows[index]);
    },
    getTotalPrice(index) {
      if (this.rows[index].product != null) {
        this.rows[index].price =
          this.products[this.rows[index].product].price *
            this.rows[index].quantity -
          this.rows[index].disc -
          this.rows[index].discPesos / this.packageInfo.dollar;
      } else {
        this.rows[index].price = 0;
        this.rows[index].quantity = 1;
      }
      this.getTotal();
    },
    getTotal() {
      this.packageInfo.subtotal = 0;
      let sumaUSD = this.rows.reduce((total, item) => {
        return item.price + total;
      }, 0);
      this.packageInfo.subtotal = sumaUSD;
      this.packageInfo.totalIVA =
        this.packageInfo.subtotal * (this.packageInfo.iva / 100);
      this.packageInfo.total =
        this.packageInfo.subtotal +
        this.packageInfo.totalIVA -
        this.packageInfo.disc -
        this.packageInfo.discPesos / this.packageInfo.dollar;
      this.packageInfo.subtotalPesos =
        this.packageInfo.subtotal * this.packageInfo.dollar;
      this.packageInfo.totalIVAPesos =
        this.packageInfo.subtotalPesos * (this.packageInfo.iva / 100);
      this.packageInfo.totalPesos =
        this.packageInfo.subtotalPesos +
        this.packageInfo.totalIVAPesos -
        this.packageInfo.disc * this.packageInfo.dollar -
        this.packageInfo.discPesos;
    },
    removeProduct(index) {
      this.rows.splice(index, 1);
      this.getTotal();
    },
    showDiscRow(index) {
      this.rows[index].showDisc = !this.rows[index].showDisc;
    },
    verifyQuantity(event) {
      event = event ? event : window.event;
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 47 && charCode < 58) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    verifyDiscount(event) {
      event = event ? event : window.event;
      var charCode = event.which ? event.which : event.keyCode;
      if ((charCode > 47 && charCode < 58) || charCode === 46) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    selectPackage() {
      let products = [];
      if (this.packageSelected === "") {
        products = [
          {
            type: null,
            product: null,
            quantity: 1,
            products: [],
            options: [...this.AllProductsOptions],
            compatibility: null,
            price: 0,
            pricePesos: 0,
            disc: 0,
            discPesos: 0,
            showDisc: false
          }
        ];
      } else {
        const selectedPackage = this.packages.filter(
          pack => pack.packageName === this.packageSelected
        )[0];

        selectedPackage.products.map(element => {
          let options = [this.AllProductsOptions[0]];
          const newOptions = this.products.filter(
            p => p.type._id == element.type
          );
          newOptions.map(p => {
            if (p.brand != null) {
              options.push({
                text: `${p.productName} Marca: ${p.brand.name}`,
                value: this.products.indexOf(p)
              });
            } else {
              options.push({
                text: `${p.productName} Marca: N/A`,
                value: this.products.indexOf(p)
              });
            }
          });
          const p = this.products.filter(e => e._id === element.product);
          if (p.length > 0) {
            const productIndex = this.products.indexOf(p[0]);
            products.push({
              type: element.type,
              product: productIndex,
              quantity: element.quantity,
              options: options,
              compatibility: null,
              price:
                this.products[productIndex].price * element.quantity -
                element.disc -
                element.discPesos / this.packageInfo.dollar,
              pricePesos: 0,
              disc: element.disc,
              discPesos: element.discPesos,
              showDisc: false
            });
          }
        });
      }

      this.rows = products;
      this.getTotal();
    }
  },
  computed: {
    total() {
      return (this.data.cotizacion.informacion_consumo.consumo_mensual
        .reduce((acc, item) => Number(acc) + Number(item.precio), 0)/2)
        .toFixed(2);
    },
    consumo_total() {
      return (
        this.data.cotizacion.informacion_consumo.consumo_mensual.reduce(
          (acc, item) => Number(acc) + Number(item.consumo),
          0
        ) / 2
      ).toFixed(2);
    },
    tamano() {
      let consumo_total = this.data.cotizacion.informacion_consumo.consumo_mensual.reduce(
        (acc, item) => Number(acc) + Number(item.consumo),
        0
      );
      let porcentaje =
        this.data.cotizacion.informacion_consumo.porcentaje_cobertura / 100;
      let consumo_total_porcentaje =
        this.data.cotizacion.informacion_consumo.consumo_mensual.reduce(
          (acc, item) => Number(acc) + Number(item.consumo),
          0
        ) * porcentaje;

      this.data.cotizacion.costo_promedio_tarifa = (
        parseFloat(this.total / 2) /
        1.16 /
        parseFloat(this.consumo_total)
      ).toFixed(2);
      return (
        consumo_total_porcentaje /
        this.data.cotizacion.ubicacion.Generacion /
        2
      ).toFixed(2);
    },
    ProduccionMensual() {
      let consumo_total = this.data.cotizacion.informacion_consumo.consumo_mensual.reduce(
        (acc, item) => Number(acc) + Number(item.consumo),
        0
      );
      let porcentaje =
        this.data.cotizacion.informacion_consumo.porcentaje_cobertura / 100;
      let consumo_total_porcentaje =
        this.data.cotizacion.informacion_consumo.consumo_mensual.reduce(
          (acc, item) => Number(acc) + Number(item.consumo),
          0
        ) * porcentaje;
      let tamano_sistema = (
        consumo_total_porcentaje / this.data.cotizacion.ubicacion.Generacion
      ).toFixed(2);
      return (
        (tamano_sistema * this.data.cotizacion.ubicacion.Generacion) /
        12 /
        2
      ).toFixed(2);
    }
  }
};
</script>
<style>